import React, { ReactNode } from "react";

import { Info } from "../../components/svg/svgImageList";
import useThemeService from "../../services/theme-service/ThemeService";
import {
  TranslationContext,
  translationService,
} from "../../services/translation/TranslationService";
import { Dialog, DialogOkButton } from "../dialog/Dialog";

interface InformationBeforeActionProps {
  titleKey: string;
  titleContext?: TranslationContext;
  subtitleKey?: string;
  buttonOk: DialogOkButton;
  children?: ReactNode;
  isVisible: boolean;
  toggleModal: () => void;
  optionalWarningKey?: string;
  optionalWarningContext?: TranslationContext;
}

export default function InformationBeforeAction(props: InformationBeforeActionProps) {
  const { themeClass } = useThemeService();

  const infoIcon = {
    svg: Info,
    width: 30,
    height: 30,
    className: themeClass(["icon-info"]),
  };

  if (!props.isVisible) return null;

  return (
    <Dialog
      isVisible={props.isVisible}
      onHide={props.toggleModal}
      iconTitle={infoIcon}
      titleKey={props.titleKey}
      titleContext={props.titleContext}
      subTextKey={props.subtitleKey}
      buttonOk={props.buttonOk}
    >
      {props.children}
      {props.optionalWarningKey &&
        translationService.translate(props.optionalWarningKey, props.optionalWarningContext)}
    </Dialog>
  );
}
